<template>
  <div class="addNote">
    <el-card class="box-card">
      <el-form ref="addForm" :model="addForm" :label-width="formLabelWidth" :rules="addFormRules">
        <el-row>
          <el-col :sm="24" :md="24" :lg="16">
            <el-form-item label="标题" prop="title">
              <el-input
                v-model="addForm.title"
                placeholder="请输入标题"
                auto-complete="off"
                maxlength="100"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :sm="24" :md="24" :lg="16">
            <el-form-item label="视频" prop="name">
              <el-upload
                class="upload-demo"
                :action="fileAction"
                :on-success="handleSuccess"
                :headers="reqData"
                :file-list="fileList"
                :before-upload="beforeAvatarUpload"
              >
                <div class="addNote-button">点击上传</div>
              </el-upload>
              <span>请上传MP4格式视频</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :sm="24" :md="24" :lg="16">
            <el-form-item label prop="name">
              <el-table :data="addForm.attachments" border style="width: 100%">
                <el-table-column prop="name" label="附件"></el-table-column>
                <el-table-column label="操作" width="150">
                  <template slot-scope="scope">
                    <i class="research-icon el-icon-download" @click="down(scope.row)"></i>
                    <i class="research-icon el-icon-delete" @click="delect(scope.row)"></i>
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :sm="24" :md="24" :lg="16">
            <el-form-item label prop="name">
              <div>
                <el-button @click="goBack">取消</el-button>
                <el-button type="primary" @click="submit">提交</el-button>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
  </div>
</template>
<script>
import UE from "../conmom/CKEditor.vue";
export default {
  components: { UE },
  data() {
    return {
      postDisabled: false,
      fileObj: {
        url: process.env.BASE_URL + "/system/uploadFile"
      },
      addForm: {
        title: "",
        content: "",
        chapterId: JSON.parse(localStorage.getItem('jump')).chapterId,
        attachments: []
      },
      tableData: [],
      formLabelWidth: "80px",
      addFormRules: {
        title: [
          {
            required: true,
            message: "请输入标题",
            trigger: "blur"
          },
          {
            min: 1,
            max: 100,
            message: "标题长度在1到100个字"
          }
        ],
        content: [
          {
            required: true,
            message: "请输入详细介绍",
            trigger: "blur"
          },
          {
            min: 1,
            max: 65535,
            message: "详细介绍长度在1到65535个字"
          }
        ]
      },
      fileAction:`${process.env.BASE_URL}/chapterMaterials/upload`,
      fileList: [],
      jump: {}
    };
  },
  methods: {
    getChapterMaterials() {
      this.jump = JSON.parse(localStorage.getItem('jump'));
      if (this.jump.state === 2 || this.jump.state === 4) {
        let obj = {
          id: this.jump.chapterId
        };
        this.api.chapterMaterials.getChapterMaterials(obj).then(result => {
          if (result.data.attachments != []) {
            for (let num in result.data.attachments) {
              result.data.attachments[num].index = num;
            }
          }
          this.addForm = result.data;
        });
      } else {
      }
    },
    beforeAvatarUpload(file) {
      console.log("file",file)
        const isMP4 = file.type === 'video/mp4';
        if (!isMP4) {
          this.$message.error('上传视频只能是 MP4 格式!');
        }
        return isMP4;
    },
    handleSuccess(response, file, fileList, $event) {
      let obj = {
        name: file.raw.name,
        size: file.raw.size,
        type: file.raw.type,
        url: response.data.url
      };
      this.addForm.attachments.push(obj);
      for (let i in this.addForm.attachments) {
        this.addForm.attachments[i].index = i;
        this.addForm.attachments[i].url = this.addForm.attachments[i].url.split(
          "?"
        )[0];
      }
      if(this.jump.state==2){
        obj.objectId = this.addForm.id;
        this.api.attachment
              .addAttachment(obj)
              .then(result => {})
      }
    },
    down(item) {
      window.open(item.url);
    },
    delect(item) {
      this.$confirm("系统将删除该附件，是否确认删除？", "系统消息", {
        type: "warning"
      })
        .then(() => {
          if (item.id == undefined) {
            this.addForm.attachments.splice(item.index, 1);
          } else {
            let obj = {
              id: item.id
            };
            this.api.attachment.deleteAttachment([obj]).then(result => {});
            this.addForm.attachments.splice(item.index, 1);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    goBack(){
      this.$router.push({path: "/teachingResearch"})
    },
    submit() {
      if (this.jump.state == 1) {
        this.addDefaultChapterMaterials();
      }
      else if(this.jump.state == 2){
        this.updateDefaultChapterMaterials();
      }
      else if(this.jump.state == 3){
        this.addChapterMaterials();
      }
      else if(this.jump.state == 4){
        this.updateChapterMaterials();
      }
    },
    updateChapterMaterials() {
        this.addForm.type = this.jump.type;
        this.$refs.addForm.validate(valid => {
          if (valid) {
            this.api.chapterMaterials
              .updateChapterMaterials(this.addForm)
              .then(result => {
                if (result.success) {
                  this.$router.push({
                    path: "/teachingResearch"
                  });
                } else {
                  this.$message.error(result.message);
                }
              })
              .catch(error => {
                console.log(error);
              });
          } else {
            return false;
          }
        });
    },
    updateDefaultChapterMaterials() {
        this.addForm.type = this.jump.type;
        this.$refs.addForm.validate(valid => {
          if (valid) {
            this.api.chapterMaterials
              .updateDefaultChapterMaterials(this.addForm)
              .then(result => {
                if (result.success) {
                  this.$router.push({
                    path: "/teachingResearch"
                  });
                } else {
                  this.$message.error(result.message);
                }
              })
              .catch(error => {
                console.log(error);
              });
          } else {
            return false;
          }
        });
    },
    addChapterMaterials() {
        this.addForm.type = this.jump.type;
        this.$refs.addForm.validate(valid => {
          if (valid) {
            this.api.chapterMaterials
              .addChapterMaterials(this.addForm)
              .then(result => {
                console.log(result);
                if (result.success) {
                  this.$router.push({
                    path: "/teachingResearch"
                  });
                } else {
                  this.$message.error(result.message);
                }
              })
              .catch(error => {
                console.log(error);
              });
          } else {
            return false;
          }
        });
    },
    addDefaultChapterMaterials() {
        this.addForm.type = this.jump.type;
        this.$refs.addForm.validate(valid => {
          if (valid) {
            this.api.chapterMaterials
              .addDefaultChapterMaterials(this.addForm)
              .then(result => {
                console.log(result);
                if (result.success) {
                  this.$router.push({
                    path: "/teachingResearch"
                  });
                } else {
                  this.$message.error(result.message);
                }
              })
              .catch(error => {
                console.log(error);
              });
          } else {
            return false;
          }
        });
    }
  },
  computed: {
    reqData() {
      return this.$store.state.user;
    }
  },
  mounted() {
    this.getChapterMaterials();
  }
};
</script>
<style scoped>
.addNote {
  background-color: #fff;
}
.addNote-button {
  height: 32px;
  width: 100px;
  border: 1px solid rgba(77, 148, 255, 1);
  color: rgba(77, 148, 255, 1);
  text-align: center;
  line-height: 34px;
  cursor: pointer;
}
.research-icon {
  margin: 0px 10px;
  font-size: 18px;
  color: #409eff;
}
</style>
<style lang="less">
.addNote {
  .el-form-item__content {
    white-space: normal !important;
  }
  .el-upload-list {
    display: none !important;
  }
  .el-table thead {
    line-height: 20px !important;
  }
  .el-table .el-table__row {
    height: 40px !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/teachingResearch/addVideo.vue